import { kebabCase } from 'lodash';
import React, { FC, useLayoutEffect } from 'react';
import { PageLoading } from 'components/atoms/loading';
import { AccountContext } from 'contexts';
import { useAccountDataQuery } from 'queries/account';

export const AccountProvider: FC = ({ children }) => {
  const { data } = useAccountDataQuery();

  useLayoutEffect(() => {
    if (data) {
      const {
        account: { metaData },
      } = data;

      if (metaData) {
        const { theme } = metaData;

        if (theme) {
          const root = document.documentElement;

          Object.keys(theme).forEach((variable) => {
            const variableValue = theme[variable];

            if (variableValue) {
              root.style.setProperty(`--${kebabCase(variable)}`, variableValue);
            }
          });
        }
      }
    }
  }, [data]);

  if (data) {
    return (
      <AccountContext.Provider value={data.account}>
        {children}
      </AccountContext.Provider>
    );
  }

  return <PageLoading size="large" />;
};
